module.exports = __webpack_public_path__ + "media/images/docicon-589506132dcb2b0eb8d3f78492b3d19b.png";